import React, { useState, useEffect } from 'react';

const directionArray = [
  { name: 'to top', value: 'to-t' },
  { name: 'to top left', value: 'to-tl' },
  { name: 'to top right', value: 'to-tr' },
  { name: 'to bottom', value: 'to-b' },
  { name: 'to bottom left', value: 'to-bl' },
  { name: 'to bottom right', value: 'to-br' },
  { name: 'to left', value: 'to-l' },
  { name: 'to right', value: 'to-r' },
]

const GradientGenerator = () => {
  const [startColor, setStartColor] = useState('cyan-500');
  const [viaColor, setViaColor] = useState('teal-500')
  const [endColor, setEndColor] = useState('pink-500');
  const [iscopy, setIscopy] = useState(false)
  const [direction, setDirection] = useState(directionArray[0]);
  const [previewStartColor, setpreviewStartColor] = useState('#2dd4bf')
  const [previewViaColor, setpreviewViaColor] = useState('#60a5fa')
  const [previewEndColor, setpreviewEndColor] = useState('#e879f9')
  const [previewDirection, setpreviewDirection] = useState('')
  const [activeTab, setActiveTab] = useState('from');
  const [selectedColor, setSelectedColor] = useState(null);

  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode !== null) {
      return savedMode === "true";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });


  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


  const colors = [
    { name: 'slate-50', value: '#f9fafb' },
    { name: 'slate-100', value: '#f4f5f7' },
    { name: 'slate-200', value: '#e5e7eb' },
    { name: 'slate-300', value: '#d1d5db' },
    { name: 'slate-400', value: '#9ca3af' },
    { name: 'slate-500', value: '#6b7280' },
    { name: 'slate-600', value: '#4b5563' },
    { name: 'slate-700', value: '#374151' },
    { name: 'slate-800', value: '#1f2937' },
    { name: 'slate-900', value: '#111827' },
    { name: 'slate-950', value: '#0c0e13' },
    { name: 'gray-50', value: '#f9fafb' },
    { name: 'gray-100', value: '#f3f4f6' },
    { name: 'gray-200', value: '#e5e7eb' },
    { name: 'gray-300', value: '#d1d5db' },
    { name: 'gray-400', value: '#9ca3af' },
    { name: 'gray-500', value: '#6b7280' },
    { name: 'gray-600', value: '#4b5563' },
    { name: 'gray-700', value: '#374151' },
    { name: 'gray-800', value: '#1f2937' },
    { name: 'gray-900', value: '#111827' },
    { name: 'gray-950', value: '#0c0e13' },
    { name: 'zinc-50', value: '#f9fafb' },
    { name: 'zinc-100', value: '#f3f4f6' },
    { name: 'zinc-200', value: '#e5e7eb' },
    { name: 'zinc-300', value: '#d1d5db' },
    { name: 'zinc-400', value: '#9ca3af' },
    { name: 'zinc-500', value: '#6b7280' },
    { name: 'zinc-600', value: '#4b5563' },
    { name: 'zinc-700', value: '#374151' },
    { name: 'zinc-800', value: '#1f2937' },
    { name: 'zinc-900', value: '#111827' },
    { name: 'zinc-950', value: '#0c0e13' },
    { name: 'neutral-50', value: '#f9fafb' },
    { name: 'neutral-100', value: '#f4f5f7' },
    { name: 'neutral-200', value: '#e5e7eb' },
    { name: 'neutral-300', value: '#d1d5db' },
    { name: 'neutral-400', value: '#9ca3af' },
    { name: 'neutral-500', value: '#6b7280' },
    { name: 'neutral-600', value: '#4b5563' },
    { name: 'neutral-700', value: '#374151' },
    { name: 'neutral-800', value: '#1f2937' },
    { name: 'neutral-900', value: '#111827' },
    { name: 'neutral-950', value: '#0c0e13' },
    { name: 'stone-50', value: '#f8fafb' },
    { name: 'stone-100', value: '#f1f5f9' },
    { name: 'stone-200', value: '#e2e8f0' },
    { name: 'stone-300', value: '#cbd5e1' },
    { name: 'stone-400', value: '#94a3b8' },
    { name: 'stone-500', value: '#64748b' },
    { name: 'stone-600', value: '#475569' },
    { name: 'stone-700', value: '#334155' },
    { name: 'stone-800', value: '#1e293b' },
    { name: 'stone-900', value: '#0f172a' },
    { name: 'stone-950', value: '#090e1e' },
    { name: 'red-50', value: '#FEF2F2' },
    { name: 'red-100', value: '#FEE2E2' },
    { name: 'red-200', value: '#FECACA' },
    { name: 'red-300', value: '#FCA5A5' },
    { name: 'red-400', value: '#F87171' },
    { name: 'red-500', value: '#EF4444' },
    { name: 'red-600', value: '#DC2626' },
    { name: 'red-700', value: '#B91C1C' },
    { name: 'red-800', value: '#991B1B' },
    { name: 'red-900', value: '#7F1D1D' },
    { name: 'red-950', value: '#3B0D0C' },
    { name: 'orange-50', value: '#FFFAF0' },
    { name: 'orange-100', value: '#FEEBC8' },
    { name: 'orange-200', value: '#FBD38D' },
    { name: 'orange-300', value: '#FFA74D' },
    { name: 'orange-400', value: '#FB923C' },
    { name: 'orange-500', value: '#F97316' },
    { name: 'orange-600', value: '#EA580C' },
    { name: 'orange-700', value: '#C2410C' },
    { name: 'orange-800', value: '#9A3412' },
    { name: 'orange-900', value: '#7C2D12' },
    { name: 'orange-950', value: '#341A00' },
    { name: 'amber-50', value: '#fffbeb' },
    { name: 'amber-100', value: '#fef3c7' },
    { name: 'amber-200', value: '#fde68a' },
    { name: 'amber-300', value: '#fcd34d' },
    { name: 'amber-400', value: '#fbbf24' },
    { name: 'amber-500', value: '#f59e0b' },
    { name: 'amber-600', value: '#d97706' },
    { name: 'amber-700', value: '#b45309' },
    { name: 'amber-800', value: '#92400e' },
    { name: 'amber-900', value: '#78350f' },
    { name: 'amber-950', value: '#60230b' },
    { name: 'yellow-50', value: '#fefce8' },
    { name: 'yellow-100', value: '#fef9c3' },
    { name: 'yellow-200', value: '#fef08a' },
    { name: 'yellow-300', value: '#fde047' },
    { name: 'yellow-400', value: '#facc15' },
    { name: 'yellow-500', value: '#eab308' },
    { name: 'yellow-600', value: '#ca8a04' },
    { name: 'yellow-700', value: '#a16207' },
    { name: 'yellow-800', value: '#854d0e' },
    { name: 'yellow-900', value: '#713f12' },
    { name: 'yellow-950', value: '#602c0b' },
    { name: 'lime-50', value: '#f7fee7' },
    { name: 'lime-100', value: '#ecfccb' },
    { name: 'lime-200', value: '#d9f99d' },
    { name: 'lime-300', value: '#bef264' },
    { name: 'lime-400', value: '#a3e635' },
    { name: 'lime-500', value: '#84cc16' },
    { name: 'lime-600', value: '#65a30d' },
    { name: 'lime-700', value: '#4d7c0f' },
    { name: 'lime-800', value: '#3f6212' },
    { name: 'lime-900', value: '#365314' },
    { name: 'lime-950', value: '#2f490b' },
    { name: 'green-50', value: '#f0fdf4' },
    { name: 'green-100', value: '#c6f6d5' },
    { name: 'green-200', value: '#9ae6b4' },
    { name: 'green-300', value: '#68d391' },
    { name: 'green-400', value: '#48bb78' },
    { name: 'green-500', value: '#38a169' },
    { name: 'green-600', value: '#2f855a' },
    { name: 'green-700', value: '#276749' },
    { name: 'green-800', value: '#22543d' },
    { name: 'green-900', value: '#1c4532' },
    { name: 'green-950', value: '#171e1a' },
    { name: 'emerald-50', value: '#ecfdf5' },
    { name: 'emerald-100', value: '#d1fae5' },
    { name: 'emerald-200', value: '#a7f3d0' },
    { name: 'emerald-300', value: '#6ee7b7' },
    { name: 'emerald-400', value: '#34d399' },
    { name: 'emerald-500', value: '#10b981' },
    { name: 'emerald-600', value: '#059669' },
    { name: 'emerald-700', value: '#047857' },
    { name: 'emerald-800', value: '#065f46' },
    { name: 'emerald-900', value: '#064e3b' },
    { name: 'emerald-950', value: '#0e261e' },
    { name: 'teal-50', value: '#f0fdfa' },
    { name: 'teal-100', value: '#ccfbf1' },
    { name: 'teal-200', value: '#99f6e4' },
    { name: 'teal-300', value: '#5eead4' },
    { name: 'teal-400', value: '#2dd4bf' },
    { name: 'teal-500', value: '#14b8a6' },
    { name: 'teal-600', value: '#0d9488' },
    { name: 'teal-700', value: '#0f766e' },
    { name: 'teal-800', value: '#115e59' },
    { name: 'teal-900', value: '#134e4a' },
    { name: 'teal-950', value: '#1e2822' },
    { name: 'cyan-50', value: '#ecfeff' },
    { name: 'cyan-100', value: '#cffafe' },
    { name: 'cyan-200', value: '#a5f3fc' },
    { name: 'cyan-300', value: '#67e8f9' },
    { name: 'cyan-400', value: '#22d3ee' },
    { name: 'cyan-500', value: '#06b6d4' },
    { name: 'cyan-600', value: '#0891b2' },
    { name: 'cyan-700', value: '#0e7490' },
    { name: 'cyan-800', value: '#155e75' },
    { name: 'cyan-900', value: '#164e63' },
    { name: 'cyan-950', value: '#1c3d5a' },
    { name: 'sky-50', value: '#f0f9ff' },
    { name: 'sky-100', value: '#e0f2fe' },
    { name: 'sky-200', value: '#bae6fd' },
    { name: 'sky-300', value: '#7dd3fc' },
    { name: 'sky-400', value: '#38bdf8' },
    { name: 'sky-500', value: '#0ea5e9' },
    { name: 'sky-600', value: '#0284c7' },
    { name: 'sky-700', value: '#0369a1' },
    { name: 'sky-800', value: '#075985' },
    { name: 'sky-900', value: '#0c4a6e' },
    { name: 'sky-950', value: '#022c43' },
    { name: 'blue-50', value: '#eff6ff' },
    { name: 'blue-100', value: '#dbeafe' },
    { name: 'blue-200', value: '#bfdbfe' },
    { name: 'blue-300', value: '#93c5fd' },
    { name: 'blue-400', value: '#60a5fa' },
    { name: 'blue-500', value: '#3b82f6' },
    { name: 'blue-600', value: '#2563eb' },
    { name: 'blue-700', value: '#1d4ed8' },
    { name: 'blue-800', value: '#1e40af' },
    { name: 'blue-900', value: '#1e3a8a' },
    { name: 'blue-950', value: '#202e78' },
    { name: 'indigo-50', value: '#eef2ff' },
    { name: 'indigo-100', value: '#e0e7ff' },
    { name: 'indigo-200', value: '#c7d2fe' },
    { name: 'indigo-300', value: '#a5b4fc' },
    { name: 'indigo-400', value: '#818cf8' },
    { name: 'indigo-500', value: '#6366f1' },
    { name: 'indigo-600', value: '#4f46e5' },
    { name: 'indigo-700', value: '#4338ca' },
    { name: 'indigo-800', value: '#3730a3' },
    { name: 'indigo-900', value: '#312e81' },
    { name: 'indigo-950', value: '#2a293e' },
    { name: 'violet-50', value: '#f5f3ff' },
    { name: 'violet-100', value: '#ede9fe' },
    { name: 'violet-200', value: '#ddd6fe' },
    { name: 'violet-300', value: '#c4b5fd' },
    { name: 'violet-400', value: '#a78bfa' },
    { name: 'violet-500', value: '#8b5cf6' },
    { name: 'violet-600', value: '#7c3aed' },
    { name: 'violet-700', value: '#6d28d9' },
    { name: 'violet-800', value: '#5b21b6' },
    { name: 'violet-900', value: '#4c1d95' },
    { name: 'violet-950', value: '#3c1d79' },
    { name: 'purple-50', value: '#faf5ff' },
    { name: 'purple-100', value: '#f3e8ff' },
    { name: 'purple-200', value: '#e9d5ff' },
    { name: 'purple-300', value: '#d8b4fe' },
    { name: 'purple-400', value: '#c084fc' },
    { name: 'purple-500', value: '#a855f7' },
    { name: 'purple-600', value: '#9333ea' },
    { name: 'purple-700', value: '#7e22ce' },
    { name: 'purple-800', value: '#6b21a8' },
    { name: 'purple-900', value: '#581c87' },
    { name: 'purple-950', value: '#4c1d70' },
    { name: 'fuchsia-50', value: '#fdf4ff' },
    { name: 'fuchsia-100', value: '#fae8ff' },
    { name: 'fuchsia-200', value: '#f5d0fe' },
    { name: 'fuchsia-300', value: '#f0abfc' },
    { name: 'fuchsia-400', value: '#e879f9' },
    { name: 'fuchsia-500', value: '#d946ef' },
    { name: 'fuchsia-600', value: '#c026d3' },
    { name: 'fuchsia-700', value: '#a21caf' },
    { name: 'fuchsia-800', value: '#86198f' },
    { name: 'fuchsia-900', value: '#701a75' },
    { name: 'fuchsia-950', value: '#5e176e' },
    { name: 'pink-50', value: '#fdf2f8' },
    { name: 'pink-100', value: '#fce7f3' },
    { name: 'pink-200', value: '#fbcfe8' },
    { name: 'pink-300', value: '#f9a8d4' },
    { name: 'pink-400', value: '#f472b6' },
    { name: 'pink-500', value: '#ec4899' },
    { name: 'pink-600', value: '#db2777' },
    { name: 'pink-700', value: '#be185d' },
    { name: 'pink-800', value: '#9d174d' },
    { name: 'pink-900', value: '#831843' },
    { name: 'pink-950', value: '#6f1322' },
    { name: 'rose-50', value: '#fff1f2' },
    { name: 'rose-100', value: '#ffe4e6' },
    { name: 'rose-200', value: '#fecdd3' },
    { name: 'rose-300', value: '#fda4af' },
    { name: 'rose-400', value: '#fb7185' },
    { name: 'rose-500', value: '#f43f5e' },
    { name: 'rose-600', value: '#e11d48' },
    { name: 'rose-700', value: '#be123c' },
    { name: 'rose-800', value: '#9f1239' },
    { name: 'rose-900', value: '#881337' },
    { name: 'rose-950', value: '#6f112c' },

  ];


  const gradientCode = `bg-gradient-${direction.value} from-${startColor} via-${viaColor} to-${endColor}`;


  const handleCopy = () => {
    navigator.clipboard.writeText(gradientCode);
    setIscopy(true);
    setTimeout(() => setIscopy(false), 2000);
  };


  const handleDirectionChange = (e) => {
    const newDirection = directionArray.find((d) => d.value === e.target.value);
    setDirection(newDirection);
  };

  useEffect(() => {
    const newPreviewDirection = directionArray.find((d) => d.name === direction.name);
    setpreviewDirection(newPreviewDirection);
    const body = document.querySelector("body");
    isDarkMode ? body.classList.add("dark") : body.classList.remove("dark");
    localStorage.setItem("darkMode", isDarkMode.toString());
    // console.log('preview direction' + previewDirection);
  }, [direction, isDarkMode]);




  return (
    <>

      <div className="flex min-h-screen bg-white dark:bg-slate-900">
        <div className="w-1/2 text-center">
          <button
            // bg-slate-200 hover:bg-slate-300 text-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200
            className={`${activeTab === 'from' ? 'bg-slate-400 dark:bg-slate-600 dark:text-slate-100' : 'bg-slate-200 hover:bg-slate-300 text-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200'
              } font-bold py-1 px-10 rounded-bl-2xl`}
            onClick={() => handleTabClick('from')}
          >
            From Color
          </button>
          <button
            className={`${activeTab === 'via' ? 'bg-slate-400 dark:bg-slate-600 dark:text-slate-100' : 'bg-slate-200 hover:bg-slate-300 text-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200'
              } font-bold py-1 px-10`}
            onClick={() => handleTabClick('via')}
          >
            Via Color
          </button>
          <button
            className={`${activeTab === 'to' ? 'bg-slate-400 dark:bg-slate-600 dark:text-slate-100' : 'bg-slate-200 hover:bg-slate-300 text-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200'
              } font-bold py-1 px-10 rounded-br-2xl`}
            onClick={() => handleTabClick('to')}
          >
            To Color
          </button>

          <div>
            {
              activeTab === 'from' &&

              <>
                <div className="grid grid-cols-11 h-3/4 mt-3 ml-6 mr-2 space-y-1 pt-5 pb-5 rounded-t-2xl bg-slate-200 dark:bg-slate-800 shadow-xl shadow-slate-300 dark:shadow-slate-900">
                  {colors.map(color => (
                    <button
                      key={color.name}
                      className={`border-2 ml-3 border-white dark:border-slate-900 h-6 w-10 shadow-sm hover:shadow-lg rounded hover:rounded-lg transition-all p-0 m-0 outline-none focus:outline-none`}
                      style={{ backgroundColor: color.value }}
                      onClick={() => {
                        setStartColor(color.name)
                        setpreviewStartColor(color.value)
                        setSelectedColor(color.name);
                        // console.log('preview start color' + previewStartColor);
                      }}
                    >{selectedColor === color.name ? '👻' : ''}</button>
                  ))}
                </div>
              </>


            }
            {activeTab === 'via' &&
              <div className="grid grid-cols-11 mt-3 ml-6 mr-2 space-y-1 pt-5 pb-5 rounded-t-2xl bg-slate-200 dark:bg-slate-800 shadow-xl shadow-slate-300 dark:shadow-slate-900">
                {colors.map(color => (
                  <button
                    key={color.name}
                    className={`border-2 ml-3 border-white dark:border-slate-900 h-6 w-10 shadow-sm hover:shadow-lg rounded hover:rounded-lg transition-all p-0 m-0 outline-none focus:outline-none`}
                    style={{ backgroundColor: color.value }}
                    onClick={() => {
                      setViaColor(color.name)
                      setSelectedColor(color.name);
                      setpreviewViaColor(color.value)
                      // console.log('preview end color' + previewEndColor);
                    }}
                  >{selectedColor === color.name ? '👻' : ''}</button>
                ))}
              </div>
            }
            {activeTab === 'to' &&
              <div className="grid grid-cols-11 mt-3 ml-6 mr-2 space-y-1 pt-5 pb-5 rounded-t-2xl bg-slate-200 dark:bg-slate-800 shadow-xl shadow-slate-300 dark:shadow-slate-900">
                {colors.map(color => (
                  <button
                    key={color.name}
                    className={`border-2 ml-3 border-white dark:border-slate-900 h-6 w-10 shadow-sm hover:shadow-lg rounded hover:rounded-lg transition-all p-0 m-0 outline-none focus:outline-none`}
                    style={{ backgroundColor: color.value }}
                    onClick={() => {
                      setEndColor(color.name)
                      setSelectedColor(color.name);
                      setpreviewEndColor(color.value)
                      // console.log('preview end color' + previewEndColor);
                    }}
                  >{selectedColor === color.name ? '👻' : ''}</button>
                ))}
              </div>
            }
          </div>
        </div>

        <div className='w-1/2 text-center justify-center'>

        <button
              className="bg-slate-200 hover:bg-slate-300 text-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200 p-2 rounded-b-2xl font-bold py-1 px-10 "
              onClick={() => setIsDarkMode(!isDarkMode)}
            >
              {isDarkMode ? "Light Mode" : "Dark Mode"}
            </button>

          {/* <div className='mt-3 rounded-t-2xl mr-10 h-1/2' style={{ background: `linear-gradient(${previewDirection.name}, ${previewStartColor}, ${previewViaColor}, ${previewEndColor})` }}> */}
          <div className='mt-3 rounded-t-2xl mr-10 h-3/4' style={{ background: `linear-gradient(${previewDirection.name}, ${previewStartColor}, ${previewViaColor}, ${previewEndColor})` }}>
          </div>

          <div className="flex flex-col mr-10 shadow-xl shadow-slate-300 dark:shadow-slate-900">
            <pre className="bg-slate-200 hover:bg-slate-300 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200 hover:cursor-pointer p-2 w-full font-bold" onClick={handleCopy}>
              {/* {gradientCode} */}
              {iscopy ? 'Copied ✔' : gradientCode}
            </pre>

            <div className='flex w-full'>

              <select onChange={handleDirectionChange} className='w-1/2 p-2 bg-slate-200 hover:bg-slate-300 outline-none focus:outline-none dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200 font-bold'>
                {directionArray.map(direction => (
                  <option key={direction.value} value={direction.value}
                    className='bg-slate-200 w-full dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200 font-bold'
                  >
                    {direction.name}
                  </option>
                ))}
              </select>

              <button
                className="p-2 bg-slate-200 hover:bg-slate-300 text-gray-700 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-slate-200 font-bold w-1/2"
                onClick={handleCopy}
              >
                {iscopy ? 'Copied ✔' : 'Copy 📝'}
              </button>
            </div>
          </div>

        </div>
      </div>

    </>
  );

}

export default GradientGenerator